import React, { useState } from "react";

const Accordion = ({ title, content, isOpen }) => {
  const [open, setOpen] = useState(isOpen ?? false);

  return (
    <div className="w-full flex flex-col bg-white text-black rounded-lg ">
      <div
        className="w-full flex justify-between px-4 py-3 cursor-pointer select-none"
        onClick={() => setOpen(!open)}
      >
        <p className="text-lg">{title}</p>

        {open ? (
          <span className="material-icons-round">keyboard_arrow_up</span>
        ) : (
          <span className="material-symbols-outlined">keyboard_arrow_down</span>
        )}
      </div>

      {open && <div className="p-4 w-full text-left">{content}</div>}
    </div>
  );
};

export default Accordion;
